import React, { Component } from "react";
import { If } from "react-extras";
import get from "lodash/get";
import { aggregateStats } from "../../lib/stats/utils";
import StatsPageTable from "./stats_page_table";

const columnInfo = [
  {
    accessor: "title",
    Header: "Podcast Title",
  },
  {
    accessor: "count",
    Header: "Downloads",
    Cell: ({ row }) => (row.count || 0).toLocaleString(),
  },
];
class StatsShowTable extends Component {
  render() {
    return (
      <div className="stats-table">
        <If condition={Boolean(this.props.shows)}>
          <h3>Downloads For All Podcasts</h3>
          <StatsPageTable
            data={this.getData()}
            columns={columnInfo}
            defaultSorted={[
              {
                id: "count",
                desc: true,
              },
            ]}
          />
        </If>
      </div>
    );
  }

  getData = () => {
    var data = aggregateStats(this.props.data, {});
    return Object.keys(this.props.shows)
      .filter(showUUID => get(this.props.shows, [showUUID, "isVisible"]))
      .map(uuid => {
        var show = this.props.shows[uuid];
        return {
          title: show.title,
          count: get(data, [uuid, "count"], 0),
        };
      })
      .reverse();
  };
}

export default StatsShowTable;
